import React from 'react';
import { useWindowSize } from '@yme/hooks/index';
import { useSelector } from '@yme/hooks/useSelector';
import { getRTL, getSearchResultsPageUrl } from '@yme/selectors/common';
import { SearchHeroSection, SearchPageGrid } from './components';
import { useSearchPage } from './hooks';
export function SearchPage({ backgroundImage }) {
    const isRightToLeft = useSelector(getRTL);
    const searchResultsPageUrl = useSelector(getSearchResultsPageUrl);
    const { isMobileView } = useWindowSize();
    const { isInitialDataLoaded, isLoading, category, query, primaryFacets, productData, contentData, autoCorrectQueryResult, didYouMeanOptions, getProductData, getContentData, } = useSearchPage({
        isMobileView,
    });
    if (!backgroundImage) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(SearchHeroSection, { backgroundImage: backgroundImage, autoCorrectQueryResult: autoCorrectQueryResult, isRightToLeft: isRightToLeft }),
        React.createElement(SearchPageGrid, { isRightToLeft: isRightToLeft, isInitialDataLoaded: isInitialDataLoaded, isLoading: isLoading, category: category, query: query, primaryFacets: primaryFacets, productData: productData, contentData: contentData, autoCorrectQueryResult: autoCorrectQueryResult, didYouMeanOptions: didYouMeanOptions, searchResultsPageUrl: searchResultsPageUrl, getProductData: getProductData, getContentData: getContentData })));
}
